export default {
    // market
    tabNews: '뉴스',
    tabJobPostings: '채용 공고',
    marketSort: "정렬",
    marketFilter: "필터",
    marketReset: '초기화',
    marketFilterGalleries: '갤러리',
    marketFilterCategories: '카테고리',
    recent: "최신순",
    earlier: "이전",
    minuteAgo: "{count}분 전",
    hourAgo: "{count}시간 전",
    dayAgo: "{count}일 전",
    weekAgo: "{count}주 전",
    on: '에',
    readArticle: "기사 읽기",
    viewPosting: "공고 보기",
    moreNumber: "+{count}개 더보기",


    // empty content text
    noNewsArticlesFound: "뉴스 기사를 찾을 수 없습니다",
    nothingMatchSearch: "검색과 일치하는 항목을 찾을 수 없는 것 같습니다. 다른 키워드를 시도하거나 나중에 다시 확인하여 최신 업데이트를 확인하세요!",
    noJobListingsAvailable: "이용 가능한 채용 공고가 없습니다",
    noJobPostingsMatching: "검색과 일치하는 채용 공고가 없는 것 같습니다. 다른 키워드를 시도하거나 나중에 다시 방문하여 새로운 기회를 찾아보세요.",
    noAdsFound: "광고를 찾을 수 없습니다",
    noAdsFoundDesc: "현재 감지된 최근 광고가 없습니다. 잠시 후 최신 캠페인을 다시 확인해 주세요.",
    noActivitiesTrackedYet: '아직 추적된 활동이 없습니다',
    noAdsMatch: "검색과 일치하는 광고가 없습니다",
    noAdsMatchDesc: "검색 조건에 맞는 광고를 찾지 못했습니다. 키워드를 조정하거나 곧 업데이트를 다시 확인해 주세요.",
    noTrackedAnyActivities: "이 회사의 활동은 아직 추적되지 않았습니다. 나중에 다시 확인하여 업데이트를 확인하세요",
    noTechnologiesFound: '기술을 찾을 수 없습니다',
    cantFindAnyInformationOnTheTechnologies: "이 회사가 사용하는 기술에 대한 정보를 찾을 수 없습니다. 업데이트를 계속 지켜봐 주세요.",
  

    // company info
    seeLess: "접기",
    seeMore: "더 보기",


    // technology
  
  };